export const TRACK_TYPES = {
  TRACK_EVENT: "trackEvent",
  TRACK_LINK: "trackLink",

  TRACK_VIEW: "trackPageView",
};
